// import async, { DataContainer } from 'async';

// class TaskQueue {
//   public static instance: TaskQueue;
//   private queue: async.QueueObject<any>;
//   private rejectMap: Map<any, Function> = new Map();

//   constructor({ concurrency = 1 }) {
//     const worker = (task: any) => {
//       return new Promise((resolve, reject) => {
//         this.rejectMap.set(task, reject);
//         task()
//           .then(resolve)
//           .catch(() => {
//             console.error('TaskQueue error');
//           });
//       });
//     };
//     this.queue = async.queue(worker, concurrency);
//   }

//   static getInstance({ concurrency = 1 }) {
//     if (!TaskQueue.instance) {
//       TaskQueue.instance = new TaskQueue({ concurrency });
//     }
//     return TaskQueue.instance;
//   }

//   // 添加任务
//   push(task: async.AsyncFunction<any>) {
//     this.queue.push(task);
//   }

//   // 添加多个任务
//   pushAll(taskList: async.AsyncFunction<any>[]) {
//     taskList.forEach((task) => {
//       this.push(task);
//     });
//   }

//   // 移除任务
//   remove(filter: (node: DataContainer<async.AsyncFunction<any>>) => boolean) {
//     this.queue.remove(filter);
//   }

//   // 所有任务执行完毕后的回调
//   drain(callback: () => void) {
//     this.queue.drain(callback);
//   }

//   // 任务执行错误的回调
//   error(callback: (error: Error, task: async.AsyncFunction<any>) => void) {
//     this.queue.error((error, task) => {
//       callback(error, task);
//     });
//   }

//   // 队列是否空闲 (为true时表示队列中没有正在执行的任务， 即所有任务都已执行完毕)
//   isIdle() {
//     return this.queue.idle();
//   }

//   // 销毁所有队列中的任务
//   destroy() {
//     this.queue.kill();
//   }

//   cancel(task: async.AsyncFunction<any>) {
//     const reject = this.rejectMap.get(task);
//     if (reject) {
//       reject().catch(() => {
//         console.error('TaskQueue error');
//       });
//     }
//   }
// }

// export default TaskQueue;

class TaskQueue {
  private static instance: TaskQueue;
  private queue: Array<() => Promise<any>> = []; // 任务队列
  private concurrency: number; // 并发数
  private running: number = 0; // 正在执行的任务数
  private drainCallback: (() => void) | null = null;
  private rejectMap: Map<any, Function> = new Map();

  constructor({ concurrency = 1 }) {
    this.concurrency = concurrency;
  }

  static getInstance(concurrency: number = 1): TaskQueue {
    if (!TaskQueue.instance) {
      TaskQueue.instance = new TaskQueue({ concurrency });
    }
    return TaskQueue.instance;
  }

  private runNext() {
    // console.log('当前任务数:', this.running, '剩余任务数:', this.queue.length);

    if (this.queue.length === 0 && this.running === 0 && this.drainCallback) {
      this.drainCallback();
      return;
    }

    if (this.running < this.concurrency && this.queue.length > 0) {
      const task = this.queue.shift();
      if (task) {
        new Promise((resolve, reject) => {
          this.rejectMap.set(task, reject);
          this.running++;

          task().finally(() => {
            this.running > 0 && this.running--;
            this.runNext();
            this.rejectMap.delete(task);
          });
        }).catch(() => {
          console.error('Manually canceled task');
          this.running > 0 && this.running--;
          this.runNext();
        });
      }
    }
  }

  // 添加任务
  public push(task: () => Promise<any>) {
    this.queue.push(task);
    this.runNext();
  }

  // 添加多个任务
  public pushAll(taskList: Array<() => Promise<any>>) {
    taskList.forEach((task) => this.push(task));
  }

  // 全部任务完成回调
  public drain(callback: () => void) {
    this.drainCallback = callback;
  }

  // 任务队列销毁
  public destroy() {
    this.queue = [];
    this.running = 0;
    this.drainCallback = null;
  }

  // 单任务取消
  public cancel(task: () => Promise<any>) {
    const reject = this.rejectMap.get(task);
    if (reject) {
      reject();
      this.rejectMap.delete(task);
    } else {
      this.queue = this.queue.filter((t) => t !== task);
    }
  }
}

export default TaskQueue;
